import SageScreen from "kit/SageScreen";
import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
    return (
        <SageScreen>
            <h2>Page Not Found</h2>
            <p>We could not find what you are looking for. Go home!</p>
            <Link to="/home">Home</Link>
        </SageScreen>
    );
};

export default NotFound;
